import {
  FETCH_FUEL_TRACKERS_REQUEST,
  FETCH_FUEL_TRACKERS_SUCCESS,
  FETCH_FUEL_TRACKERS_FAILURE,
  CREATE_FUEL_TRACKER_REQUEST,
  CREATE_FUEL_TRACKER_SUCCESS,
  CREATE_FUEL_TRACKER_FAILURE,
  DELETE_FUEL_TRACKER_REQUEST,
  DELETE_FUEL_TRACKER_SUCCESS,
  DELETE_FUEL_TRACKER_FAILURE,
  UPDATE_FUEL_TRACKER_REQUEST,
  UPDATE_FUEL_TRACKER_SUCCESS,
  UPDATE_FUEL_TRACKER_FAILURE,
  CLEAR_FUEL_TRACKER_STATES,
} from '../constants'
import { clear } from "redux-localstorage-simple"

const defaultState = {
  pending: false,
  fetchSuccess: false,
  updateSuccess: false,
  fuelTrackers: [],
  fuelTracker: null,
}

export default (state = defaultState, action) => {

  var newState = {...state}

  switch (action.type){
    case FETCH_FUEL_TRACKERS_REQUEST:
      newState.pending = true
      newState.fetchSuccess = false
      return newState
    case FETCH_FUEL_TRACKERS_SUCCESS:
      newState.fuelTrackers = action.body;
      newState.fetchSuccess = true
      return newState
    case FETCH_FUEL_TRACKERS_FAILURE:
      newState.pending = false;
      newState.fetchSuccess = false
      return newState
    case CREATE_FUEL_TRACKER_REQUEST:
      newState.pending = true
      newState.updateSuccess = false
      return newState
    case CREATE_FUEL_TRACKER_SUCCESS:
      newState.fuelTracker = action.body;
      newState.updateSuccess = true
      return newState
    case CREATE_FUEL_TRACKER_FAILURE:
      newState.pending = false;
      newState.updateSuccess = false
      return newState
    case DELETE_FUEL_TRACKER_REQUEST:
      newState.pending = true
      newState.updateSuccess = false
      return newState
    case DELETE_FUEL_TRACKER_SUCCESS:
      newState.fuelTracker = action.body;
      newState.updateSuccess = true
      return newState
    case DELETE_FUEL_TRACKER_FAILURE:
      newState.pending = false;
      newState.updateSuccess = false
      return newState
    case UPDATE_FUEL_TRACKER_REQUEST:
      newState.pending = true
      newState.updateSuccess = false
      return newState
    case UPDATE_FUEL_TRACKER_SUCCESS:
      newState.fuelTracker = action.body;
      newState.updateSuccess = true
      return newState
    case UPDATE_FUEL_TRACKER_FAILURE:
      newState.pending = false;
      newState.updateSuccess = false
      return newState
    case CLEAR_FUEL_TRACKER_STATES:
      newState = defaultState;
      clear();
      return newState;
    default:  return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/fuelTracker.js